<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M26.6666 17.3333V25.3333C26.6666 26.8061 25.4728 27.9999 24 27.9999H7.99998C6.52722 27.9999 5.33331 26.8061 5.33331 25.3333V17.3333"
        :stroke="stroke"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 20V4M16 4L11.3333 8.66667M16 4L20.6666 8.66667"
        :stroke="stroke"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
<script>
import { DEFAULT_BRAND_SECONDARY_COLOR } from '../constants';

export default {
  inject: ['getBrandSecondaryBackground'],
  computed: {
    stroke() {
      const stroke = this.getBrandSecondaryBackground();
      console.log('brand primary background: ', stroke);
      return stroke || DEFAULT_BRAND_SECONDARY_COLOR;
    },
  },
};
</script>
